import React from 'react'

import * as UI from '../../components'
import {
  formatDateTime,
  getPurchaseURL,
  formatBigNumber,
  purchaseStatus,
} from '../../helpers'

export default ({ purchases, storefronts }) =>
  purchases && (
    <UI.List>
      {purchases.map((purchase, i) => {
        return purchase.status != null ? (
          <UI.List.Item key={i}>
            <UI.List.Header>
              {formatBigNumber(purchase.tokensClaimed)}{' '}
              {storefronts && storefronts[purchase.sale].tokenName}s
              <UI.Text size="tiny" inline uppercase>
                {' '}
                {purchaseStatus(purchase)}
              </UI.Text>
            </UI.List.Header>

            <UI.List.Description>
              <UI.Link to={getPurchaseURL(purchase.key)}>
                {formatDateTime(purchase.initiatedTime)}
              </UI.Link>
            </UI.List.Description>
          </UI.List.Item>
        ) : null
      })}
    </UI.List>
  )



// WEBPACK FOOTER //
// ./src/screens/partials/PurchasesList.js